import { useRef } from "react";

import styled from "styled-components";

import { Frame, TExtra } from "../ui-kit/styled-templates";

import FilesApi from "api/files-api";

import AlertsService from "services/alerts-service";

export type TDropzoneProps = {
    onUpload?: Function;
    onDrop?: Function;
    onChange?: Function;
    value?: string;
    accept?: string;
    clickable?: boolean;
    extra?: TExtra;
    children?: any;
    [key: string]: any;
};

const Dropzone = (props: TDropzoneProps) => {
    const {
        onUpload = async () => {},
        onDrop = async () => {},
        accept = `image/jpeg`,
        clickable = true,
        extra = ``,
        children,
        onChange = () => {},
    } = props;

    const ref = useRef();

    const ultimate = async (e: any) => {
        e.preventDefault();
        let files = e?.dataTransfer?.files || e?.target?.files;
        if (files) {
            for (let i = 0; i < files.length; i++) {
                const file = files[0];
                console.log(accept, file.type);
                if (!accept?.includes?.(file.type)) {
                    throw AlertsService.showError(`File extension is not acceptable`);
                }
                onDrop(file);
                const { url } = await FilesApi.uploadFile(file);
                onUpload(url);
                onChange({ target: { value: url } });
            }
        }
    };

    return (
        <Wrapper
            onDrop={ultimate}
            onDragOver={(e) => e.preventDefault()}
            onClick={() => clickable && (ref.current as any).click()}
            accept={accept}
            extra={(clickable ? `` : `cursor: default;`) + extra}
        >
            {clickable && <Input ref={ref} type={`file`} onChange={ultimate} accept={accept} />}
            {children}
        </Wrapper>
    );
};

const Input = styled.input<{ ref: any }>`
    display: none;
`;

const Wrapper = styled(Frame)<{ accept?: string }>`
    cursor: copy;

    ${({ extra }) => extra}
`;

export default Dropzone;
